import React from 'react';
import { cn } from '../utils/cn';

/**
 * Badge Component - Atom
 * 
 * @param {Object} props
 * @param {string} props.variant - 'default' | 'primary' | 'success' | 'error' | 'warning' | 'info'
 * @param {string} props.size - 'sm' | 'md' | 'lg'
 * @param {string} props.shape - 'rounded' | 'pill'
 */
const Badge = React.forwardRef(
  (
    {
      variant = 'default',
      size = 'md',
      shape = 'rounded',
      className = '',
      children,
      ...props
    },
    ref
  ) => {
    const baseStyles = 'inline-flex items-center font-medium';

    const variants = {
      default: 'bg-primary-100 dark:bg-primary-800 text-primary-800 dark:text-primary-200',
      primary: 'bg-primary-600 text-primary-50',
      success: 'bg-success-100 dark:bg-success-900/30 text-success-700 dark:text-success-400',
      error: 'bg-error-100 dark:bg-error-900/30 text-error-700 dark:text-error-400',
      warning: 'bg-warning-100 dark:bg-warning-900/30 text-warning-700 dark:text-warning-400',
      info: 'bg-info-100 dark:bg-info-900/30 text-info-700 dark:text-info-400',
    };

    const sizes = {
      sm: 'px-2 py-0.5 text-xs',
      md: 'px-2.5 py-1 text-sm',
      lg: 'px-3 py-1.5 text-base',
    };

    const shapes = {
      rounded: 'rounded-md',
      pill: 'rounded-full',
    };

    return (
      <span
        ref={ref}
        className={cn(
          baseStyles,
          variants[variant],
          sizes[size],
          shapes[shape],
          className
        )}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = 'Badge';

export default Badge;
